import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { getGame, setGame } from './actions';
import { selectActiveGame, selectOpponent, selectPlayer } from './selectors';
import { BoardArea, Panel, Screen, Top, TopRow, Viewport } from './styled';
import { ViewOption, ViewSwitch } from '../Controls';
import MatBoard from '../Board/MatBoard';
import TableBoard from '../Board/TableBoard';
import { MAT_VIEW, TABLE_VIEW, useBoardView } from '../Board/useBoardView';
import Card from '../Card';
import Hand from '../Hand';
import PlayerBar from '../PlayerBar';
import TurnBanner from '../TurnBanner';
import DeckLook from '../Trainer/DeckLook';
import ActivePokemonMenu from '../ActivePokemon/ActivePokemonMenu';
import BenchContextMenu from '../Bench/BenchContextMenu';
import DeckContextMenu from '../Deck/DeckContextMenu';
import DiscardPileContextMenu from '../DiscardPile/DiscardPileContextMenu';
import RetreatContextMenu from '../RetreatButton/RetreatContextMenu';
import { Muted } from '../Controls';

const Game = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const game = useSelector(selectActiveGame);
  const player = useSelector(selectPlayer);
  const opponent = useSelector(selectOpponent);
  const [view, setView] = useBoardView();

  useEffect(() => {
    if (!game) {
      dispatch(setGame(null));
      dispatch(getGame(id));
    }
  }, [dispatch, id, game]);

  if (!game) {
    return <Viewport><Muted style={{ padding: 16 }}>Loading game…</Muted></Viewport>;
  }

  const playerId = player.getIn(['user', 'id']);
  const opponentId = opponent.getIn(['user', 'id']);
  // The first player sits at the mat's printed bottom edge; the second player sees it turned.
  const turned = game.get('first_player_id') !== null && game.get('first_player_id') !== playerId;
  const userIds = [playerId, opponentId];

  return (
    <Viewport>
      <Screen>
        <BoardArea>
          {view === MAT_VIEW ?
            <MatBoard playerId={playerId} opponentId={opponentId} turned={turned} /> :
            <TableBoard playerId={playerId} opponentId={opponentId} />}
        </BoardArea>

        <Top>
          <TopRow>
            <Link to="/games">‹ Games</Link>
            <ViewSwitch role="group" aria-label="Board view">
              <ViewOption $on={view === MAT_VIEW} onClick={() => setView(MAT_VIEW)}>Mat</ViewOption>
              <ViewOption $on={view === TABLE_VIEW} onClick={() => setView(TABLE_VIEW)}>Table</ViewOption>
            </ViewSwitch>
          </TopRow>
          <PlayerBar userId={opponentId} />
        </Top>

        <Panel>
          <TurnBanner userId={playerId} />
          <PlayerBar userId={playerId} you />
          <Hand userId={playerId} />
        </Panel>
      </Screen>
      <DeckLook userId={playerId} />

      {userIds.map(userId => (
        <React.Fragment key={userId}>
          <ActivePokemonMenu userId={userId} />
          <BenchContextMenu userId={userId} />
          <DeckContextMenu userId={userId} />
          <DiscardPileContextMenu userId={userId} />
        </React.Fragment>
      ))}
      <RetreatContextMenu userId={playerId} />
      <Card />
    </Viewport>
  );
};

export default Game;
